import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { FormattedMessage, injectIntl, IntlShape } from "react-intl";
import { connect } from "react-redux";
import LimitAmount from "./components/LimitAmount/LimitAmount";
import SetYourLossLimit from "./components/SetYourLossLimit/SetYourLossLimit";
import ValidationErrorMessage from "./components/ValidationErrorMessage/ValidationErrorMessage";
import WelcomeBanner from "./components/WelcomeBanner/WelcomeBanner";
import WelcomeMessage from "./components/WelcomeMessage/WelcomeMessage";
import "./SetLimits.scss";
//
type setLimitsProps = {
  intl: IntlShape;
  handleChange: (id: string, value: string | number) => void;
  submitLossLimit: () => void;
  hideLossLimitsModal: () => void;
  errorMessage: string;
  setUpdateLossLimitsPrompt: () => void;
  isSubmittingLossLimit: boolean;
  isLossLimitSet: boolean;
};

const SetLimits = (props: setLimitsProps): JSX.Element => {
  return (
    <div className="loss-limits-form-modal__set-limits">
      <div className="form-details">
        <WelcomeBanner />
        {!props.isLossLimitSet && (
          <>
            <WelcomeMessage />
            <SetYourLossLimit
              intl={props.intl}
              handleChange={props.handleChange}
            />
            <LimitAmount intl={props.intl} handleChange={props.handleChange} />
          </>
        )}
      </div>
      {props.errorMessage && (
        <ValidationErrorMessage errorMessage={props.errorMessage} />
      )}
      {props.isLossLimitSet && (
        <div className={`form-details__row form-details__row--success-message`}>
          <FormattedMessage tagName="" id="loss-limits-now-set-text" />
        </div>
      )}
      {!props.isLossLimitSet && (
        <div className="continue-button-container">
          <button
            className="nav-bar__nav-item--contact nav-bar__nav-item--back--button"
            onClick={() => {
              props.hideLossLimitsModal();
              props.setUpdateLossLimitsPrompt();
            }}
          >
            <FormattedMessage tagName="div" id="loss-limits-later" />
          </button>
          <button
            className="nav-bar__nav-item--contact nav-bar__nav-item--contact--button"
            onClick={props.submitLossLimit}
          >
            <FormattedMessage tagName="div" id="loss-limits-set-limit" />
            {props.isSubmittingLossLimit && <LoadingSpinner />}
          </button>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  isSubmittingLossLimit: state.lossLimitsModel.isSubmittingLossLimit,
  errorMessage: state.lossLimitsModel.errorMessage,
  isLossLimitSet: state.lossLimitsModel.isLossLimitSet,
});

const mapDispatchToProps = dispatch => ({
  hideLossLimitsModal: () => dispatch.lossLimitsModel.hideLossLimitsModal(),
  setUpdateLossLimitsPrompt: () => {
    dispatch.lossLimitsModel.setUpdateLossLimitsPrompt();
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SetLimits));
